import { toZonedTime } from 'date-fns-tz';
import { startOfDay } from 'date-fns';
import { validateArguments } from '../../SignatureValidation';
export var TodayFn;
(function (TodayFn) {
    TodayFn.Name = `TODAY`;
    TodayFn.Stage = "CONST";
    TodayFn.Signature = `TODAY()`;
    function make(exprEnv, callName, args, type, role) {
        return {
            name: TodayFn.Name,
            stage: TodayFn.Stage,
            data: { type, role },
            value: () => {
                if (type.name !== "TIMESTAMP") {
                    throw new Error(`Invalid data type for fn TODAY ${type.name}`);
                }
                const todayMs = startOfDay(toZonedTime(exprEnv.now, 'Z')).getTime();
                switch (type.unit) {
                    case "SECOND":
                        return todayMs / 1000;
                    case "MICROS":
                        return todayMs * 1000;
                    case "MILLIS":
                        return todayMs;
                }
            },
        };
    }
    TodayFn.make = make;
    function validate(callNode, callName, args) {
        const sig = {
            arguments: [],
            meta: {
                name: TodayFn.Name,
                signature: TodayFn.Signature,
                location: callNode.location,
            },
        };
        return validateArguments(sig, args);
    }
    TodayFn.validate = validate;
})(TodayFn || (TodayFn = {}));
